import {
    tree as buildTree,
    isObject,
    isArray,
    isString,
    deepMixin,
    deepClone
} from "../../funcs";
import _ from "underscore";
import { mixinLangDictionaries } from "../../funcs/obj";

let tmpIndex = 0;

const parseTemplate = (template, scope) => {
    try {
        return _.template(template, {
            evaluate: /\{([\s\S]+?)\}/g,
            interpolate: /\{=([\s\S]+?)\}/g,
            escape: /\{-([\s\S]+?)\}/g
        })(deepMixin({
            if(a, b, c) {return a ? b : c;}
        }, null, scope));
    } catch (err) {
        console.log(err);
        return template;
    }
};

export default class LangDictionary {
    constructor(data, lang) {
        this._data = data;
        this.lang = lang;
        this.trees = {};
    }

    /**
     * get some text from lang/text.js
     * @param {string} key key of dictionary
     * @param {object=} scope variables for template
     * @returns {string}
     */
    get(key, scope) {
        if ( scope ) {
            return parseTemplate(this._data[key] || key, scope);
        } else {
            return this._data[key] || key;
        }
    }

    actualizeData() {
        const isConsistentData = this.isConsistentData();

        if ( !isConsistentData ) {
            this.reInitLang();
        }
    }

    isConsistentData() {
        if ( window.lang && this.lang ) {
            if ( window.lang != this.lang ) {
                return false;
            }
        }

        return true;
    }

    setLangOptions(data, lang) {
        this._data = data;
        this.lang = lang;
    }

    setLangObjects({
        FIELD_NAME,
        FORMS,
        ERROR_CODES,
        TABLE_NAMES,
        ICON_TITLES,
        REPORT_TITLES,
        MONTH_NAME,
        APPS
    }) {
        this.FIELD_NAME = FIELD_NAME;
        this.FORMS = FORMS;
        this.ERROR_CODES = ERROR_CODES;
        this.TABLE_NAMES = TABLE_NAMES;
        this.ICON_TITLES = ICON_TITLES;
        this.REPORT_TITLES = REPORT_TITLES;
        this.MONTH_NAME = MONTH_NAME;
        this.APPS = APPS;
    }

    set(key, value) {
        this._data[key] = value;
        this.trigger("change change:" + key, value);
    }

    getTableName(name) {
        return this.TABLE_NAMES[name] || name;
    }

    /**
     * get some text from lang/field_name.js
     * @param {string} tableName entity name
     * @param {string} fieldName column name
     * @param {boolean} useFieldNameOnFailure flag that indicates to return
     * fieldName in case of unsuccessful search
     * @returns {string}
     */
    getFieldTitle(tableName, fieldName, useFieldNameOnFailure = true) {
        let titles = this.FIELD_NAME[tableName];

        if ( titles === false ) {
            return useFieldNameOnFailure && fieldName;
        }

        if ( !titles ) {
            titles = this.FIELD_NAME.root;
        }

        if ( fieldName in titles ) {
            return titles[fieldName];
        } else {
            return useFieldNameOnFailure && fieldName;
        }
    }

    hasFieldTranslate(tableName, fieldName) {
        const titles = this.FIELD_NAME[tableName];
        return fieldName in titles;
    }

    // находим в каком файле хранится перевод столбца
    // пример:
    // "LIST_ALL_GTD", "DATE_CLEAR"  =>  "LIST_GTD"
    // "ORDER" . "DT_CREATE" => "root"
    getTableNameForFieldWhereTranslated(tableName, fieldName) {
        const fields = this.FIELD_NAME[tableName] || {};
        if ( fields.hasOwnProperty(fieldName) ) {
            return tableName;
        }

        if ( fields.__parentName ) {
            return this.getTableNameForFieldWhereTranslated(
                fields.__parentName,
                fieldName
            );
        }
    }

    getMonth(month) {
        return this.MONTH_NAME[month] || month;
    }

    getError(code, scope) {
        code += "";

        if ( this.ERROR_CODES[code] ) {
            code = this.ERROR_CODES[code];
        }

        else if ( code.indexOf("Error: ") && this.ERROR_CODES[code.slice(7)] ) {
            code = this.ERROR_CODES[code.slice(7)];
        }

        if ( isObject(scope) ) {
            return parseTemplate(code, scope);
        }

        return code;
    }

    getIconTitle(iconModel) {
        let name;
        let title;

        if ( isString(iconModel) ) {
            name = iconModel;
        } else {
            name = iconModel.get("name"),
            title = iconModel.get("title");
        }

        if ( title ) {
            return title;
        }

        return this.ICON_TITLES[name] || name;
    }

    getMultiCurrencyName() {
        return "Мульти";
    }

    getMultiCurrencyId() {
        return 4;
    }

    getReportTitle(name) {
        return this.REPORT_TITLES[name] || name;
    }

    getMonthNames() {
        return deepClone(this.MONTH_NAME);
    }

    getMonthName(month) {
        return this.getMonthNames()[month];
    }

    /**
     * @param {number} day new Date().getDay()
     * @returns string
     */
    getDayName(day) {
        if ( day == 0 ) {
            return this.get("WEEK_DAY_SUN");
        }
        if ( day == 1 ) {
            return this.get("WEEK_DAY_MON");
        }
        if ( day == 2 ) {
            return this.get("WEEK_DAY_TUE");
        }
        if ( day == 3 ) {
            return this.get("WEEK_DAY_WED");
        }
        if ( day == 4 ) {
            return this.get("WEEK_DAY_THU");
        }
        if ( day == 5 ) {
            return this.get("WEEK_DAY_FRI");
        }
        if ( day == 6 ) {
            return this.get("WEEK_DAY_SAT");
        }
        throw new Error(`unknown day number: ${day}`);
    }

    getTabTitle(key) {
        if ( key == "all" ) {
            return this.get("tabs_all_title");
        } else if ( key == "Доставлен" ) {
            return this.get("tabs_delivered_title");
        } else if ( key == "В работе" ) {
            return this.get("tabs_inProgress_title");
        }
        return key;
    }

    getAppTitle(key) {
        return this.APPS[ key ] || key;
    }

    getFormText(formName, key, scope) {
        const formTexts = this.FORMS[ formName ];
        if ( !formTexts ) {
            console.info("not found formTexts: " + formName);
            return key;
        }

        if ( scope ) {
            return parseTemplate(formTexts[key] || key, scope);
        } else {
            return formTexts[ key ] || key;
        }
    }

    addFields(fieldTranslatesByTableName) {
        this.addTranslates("FIELD_NAME", fieldTranslatesByTableName);
    }

    addForms(formTranslatesByFormName) {
        this.addTranslates("FORMS", formTranslatesByFormName);
    }

    addFieldsByLang(fieldsByLang) {
        let fields = fieldsByLang[ window.lang ];

        if ( window.lang != "ru" ) {
            fields = mixinLangDictionaries(
                fieldsByLang.ru,
                fieldsByLang.en
            );
        }

        this.addFields(fields);
    }

    addFormsByLang(formsByLang) {
        let forms = formsByLang[ window.lang ];

        if ( window.lang != "ru" ) {
            forms = mixinLangDictionaries(
                formsByLang.ru,
                formsByLang.en
            );
        }

        this.addForms(forms);
    }

    /**
     * Нотация перевода столбцов.
     *
     * // если не указывать таблицу в переводах,
     * то по умолчанию она приравнивается к записи:
     * MY_TABLE: "root" // удобно для простых справочников
     *
     * MY_TABLE: false // если ЯВНО не хочешь переводить столбцы (никогда не показывается юзеру)
     *
     * // алиас
     * MY_TABLE: "PARENT_TABLE"
     *
     * // наследование и замена родительских св-в
     * MY_TABLE: {
     *     "parent": "PARENT_TABLE",
     *     "REPLACE_FIELD_1": "My awesome column"
     * }
     *
     * // если не указывать "parent", то он приравнивается к "root", то есть:
     * // по умолчанию все наследуют переводы своих полей от "root" объекта.
     * MY_TABLE: {
     *     // "parent": "root" // default
     *     "FIELD_1": "My awesome column"
     * }
     *
     * MY_TABLE: {
     *     "parent": "PARENT_TABLE",
     *     "FIELD_1": false  // если не надо выводить этот столбец в журнале
     * }
     */
    addTranslates(storageKey, translatesByName) {
        let rows = [];
        let disabled = [];

        let outputTranslatesByName = this[storageKey];
        if ( !outputTranslatesByName ) {
            outputTranslatesByName = {};
            this[storageKey] = outputTranslatesByName;
        }

        // name is form name or table name
        for (let name in translatesByName) {
            let translates = translatesByName[ name ];

            if ( translates === false ) {
                disabled.push(name);
                continue;
            }

            let isValidTranslates = (
                isString(translates)
                || isObject(translates)
            );
            if ( !isValidTranslates ) {
                throw new Error("invalid translates '" + name + "'");
            }

            let row;
            if ( isString(translates) ) {
                row = {
                    id: name,
                    parent: translates
                };
            }
            else {
                row = translates;
                row.id = name;

                if ( !translates.parent ) {
                    if ( row.id != "root" ) {
                        row.parent = "root";
                    }
                }
            }

            // mixin extends (@example LIST_GTD_GOODS)
            if ( isArray(translates.parent) ) {
                let tmpRow = deepMixin(...translates.parent.map((parentName) =>
                    translates[ parentName ]
                ));

                tmpRow.id = "tmp-" + (++tmpIndex);
                tmpRow.parent = "root";

                outputTranslatesByName[ tmpRow.id ] = tmpRow;
                rows.push(tmpRow);

                row.parent = tmpRow.id;
            }

            rows.push(deepClone(row));
        }

        let tree = this.trees[ storageKey ];
        if ( !tree ) {
            tree = buildTree(rows, "id", "parent");
            this.trees[ storageKey ] = tree;

            outputTranslatesByName.root = deepClone(tree.all.root.row);
            delete outputTranslatesByName.root.id;
            delete outputTranslatesByName.root.parent;

        }
        else {
            rows.forEach((row) => {
                tree.add(row);
            });
        }

        // Чтобы создать верную цепочку прототипов, начинать надо с корня,
        // таким образом, когда дойдем до потомка он уже сможет ссылаться
        // на "готового" родителя (с прото ссылкой на другого родителя)
        createPrototypes(tree.all.root);

        function createPrototypes(parent) {
            let parentRow = outputTranslatesByName[ parent.id ];

            parent.children.elems.forEach((elem) => {

                const existsProto = (
                    elem.id in outputTranslatesByName
                );

                if ( !existsProto ) {
                    let fields = Object.create(parentRow);

                    for (let key in elem.row) {
                        if ( key == "id" ) {
                            continue;
                        }
                        if ( key == "parent" ) {
                            fields.__parentName = elem.row[ key ];
                            continue;
                        }

                        fields[ key ] = elem.row[ key ];
                    }

                    outputTranslatesByName[ elem.id ] = fields;
                }


                createPrototypes(elem);
            });
        }

        disabled.forEach((name) => {
            outputTranslatesByName[ name ] = false;
        });
    }

}
